// PaktLockup.tsx — symbol + wordmark, horizontal.

import React from 'react';
import { PaktMark, PaktMarkVariant } from './PaktMark';
import { PaktWordmark } from './PaktWordmark';

export interface PaktLockupProps {
  /** Base size (the mark renders at size * 1.3, wordmark at size * 1.1). */
  size?: number;
  color?: string;
  dotColor?: string;
  variant?: PaktMarkVariant;
  className?: string;
  style?: React.CSSProperties;
}

export function PaktLockup({
  size = 32,
  color = '#0A0A0A',
  dotColor = '#FF5B2E',
  variant = 'orange',
  className,
  style,
}: PaktLockupProps) {
  return (
    <div
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: size * 0.4,
        ...style,
      }}
    >
      <PaktMark size={size * 1.3} variant={variant} />
      <PaktWordmark size={size * 1.1} color={color} dotColor={dotColor} />
    </div>
  );
}
